import React, { useCallback } from "react";
import WrappedAlert from "./WrappedAlert";
import { useSelector, useDispatch } from "react-redux";
import { getAlerts } from "data/app/appSelectors";
import { deleteAlertAction } from "data/app/appActions";

interface AlertsProps {
	className?: string;
	isNotificationsTrayOpen: boolean;
}

const AlertsContainer = ({
	className,
	isNotificationsTrayOpen,
}: AlertsProps) => {
	// Setup container to use alerts from redux state and initialise dispatch.
	const alerts = useSelector(getAlerts);
	const dispatch = useDispatch();

	/**
	 * When an alert is deleted this handleOnClose will be triggered to dispatch the delete_alert redux action
	 */
	const handleOnClose = useCallback(
		(myId: string) => {
			dispatch(deleteAlertAction(myId));
		},
		[dispatch]
	);

	// Check whether user is currently on desktop so that alert animations change accordingly
	const isDesktop = window.innerWidth > 767;

	return (
		<div
			className={
				isNotificationsTrayOpen
					? "alert-container notifications"
					: "alert-container" + (className ? ` ${className}` : "")
			}>
			<>
				{alerts &&
					alerts.map(alert => {
						return (
							<WrappedAlert
								className={alert.className}
								dark={alert.dark}
								description={alert.description}
								list={alert.list}
								status={alert.status}
								timeout={alert.timeout}
								title={alert.title}
								id={alert.id}
								key={alert.id}
								isDesktop={isDesktop}
								onClose={(id: string) => handleOnClose(id)}
							/>
						);
					})}
			</>
		</div>
	);
};

export default AlertsContainer;
